<div
  class="card notification-card-message h-100 position-relative"
  [class]="cardType"
>
  <div class="card-body notification-card-body">
    <div class="d-flex align-items-center">
      @if (imageUrl !== '') {
        <img loading="lazy" class="notification-icon" [src]="imageUrl" alt="" />
      }
      <div class="card-content notification-card-content">
        <h4 class="card-title notification-card-title fw-bold" id="card-title">
          {{ title }}
        </h4>
        <p
          class="card-text notification-card-text"
          style="white-space: break-spaces"
          [innerHTML]="description"
        ></p>
      </div>
    </div>
    <div class="button-container ps-2">
      @if (linkText !== '' && linkUrl !== '') {
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="handleClick()"
        >
          {{ linkText }}
        </button>
      }
    </div>
  </div>

  @if (id !== null) {
    <button
      type="button"
      aria-label="Dismiss notification"
      class="btn-close"
      (click)="dismiss()"
    ></button>
  }
</div>
